export function getGroupOptionsFactoryFn(eForm) {
  return () => {
    const groups = eForm.getValueFromScope('groupArray');
    const options = groups?.map(getGroupOption) || [];

    return Promise.resolve(options);
  };
}

function getGroupOption(group) {
  return { value: group, text: group };
}
